import React from "react";
import {useNodeId, useNodes} from "@xyflow/react";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import {FaCalendar, FaCarSide, FaPalette} from "react-icons/fa";
import projectUtils from "../../../../../../utils/project-utils.js";
import {FaCarOn} from "react-icons/fa6";
import BaseNode from "./base-node.jsx";
import {Types} from "../enums.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import associationNetworkService from "../../../../../../services/web/association-network-service.js";
import {toast} from "react-toastify";
import CheckHasData from "../check-has-data.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const Vehicle = ({data, selected}) => {
    const navigate = navigateHook();
    const {toggleItemsNode, setPanelOpened, setSelectedNode, filterPassage} = useEdgeBuilder()
    const nodes = useNodes();
    const nodeId = useNodeId();

    const open = () => {
        const urlDev = `/vehicle/form/${data.plate}`
        
        navigate(urlDev, true);
    }

    const icon = (
        <img
            className="m-auto"
            src={getAssetPath("img/dashboard-svg/sw.vehicle.svg")}
            alt="image"
        />
    );

    const title = (
        <div className="vehicle-plate !w-full mx-auto !min-w-0 !border-none !rounded-none">
            <div className={"product-heading !rounded-t-[3px] " + (data?.pattern ?? 'WITHOUT_PATTERN')}></div>
            <div className={"text-[12px] product-body " + (data?.pattern ?? 'WITHOUT_PATTERN')}>
                {data.formattedValue}
            </div>
        </div>
    );

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            {
                toggleItemsNode.vehicle.brandModel &&
                <div className={"flex items-center"}>
                    <FaCarSide/>
                    <p className={"ml-1 mb-0 block overflow-hidden whitespace-nowrap text-ellipsis"}>
                        <CheckHasData value={data.brandModel} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.vehicle.color &&
                <div className={"flex items-center"}>
                    <FaPalette/>
                    <p className={"ml-1 mb-0"}><CheckHasData value={data.color} /></p>
                </div>
            }
            {
                toggleItemsNode.vehicle.year &&
                <div className={"flex items-center"}>
                    <FaCalendar/>
                    <p className={"ml-1 mb-0"}>
                        <CheckHasData value={data.modelYear} />
                    </p>
                </div>
            }
        </div>
    )

    const onSearchPassage = async () => {
        setSelectedNode(nodes.find(n => n.id === nodeId) || null);
        setPanelOpened("passages")
    }

    const openVehicleProfile = () => {
        const {plate} = data
        associationNetworkService.openVehicleProfile(plate)
            .then(() => {
                toast.success(`O perfil do veículo para a placa ${plate} será aberto no SentryView.`)
            })
            .catch(error => {
                console.error(error);
                projectUtils.swalErrorMessage("", "Ocorreu um erro ao abrir o perfil do veículo.", "Ok");
            });
    }

    const formatToBackend = (dateStr) => {
        if (!dateStr) return ""

        return dateStr.replace(' ', 'T') + ':00.000Z';
    }

    const openPassageSearch = () => {
        const {plate} = data
        const filters = new FormData();
        filters.append('plate', data.plate);
        filters.append('initialDate', formatToBackend(filterPassage.startDate));
        filters.append('finalDate', formatToBackend(filterPassage.endDate));

        associationNetworkService.openSearch(filters)
            .then(() => {
                toast.success(`A pesquisa para a placa ${plate} será aberta no SentryView.`)
            })
            .catch(error => {
                console.error(error);
                projectUtils.swalErrorMessage("", "Ocorreu um erro ao abrir a pesquisa no SentryView.", "Ok");
            });
    }

    const infoPassage = (
        <>
            {
                data.plate &&
                <>

                    <div title={`Pesquisar passages ${data.plate || ""}`}
                         onClick={openPassageSearch}
                         className="ml-1 cursor-pointer w-[18px] h-[18px] flex items-center justify-center !border !border-[#cfcfcf] bg-[#dbdbdb] rounded hover:bg-[#ccc]"
                    >
                        <FaCarSide size={8} color="#333"/>
                    </div>

                    <div title={`Perfil do veículo ${data.plate || ""}`}
                         onClick={openVehicleProfile}
                         className="ml-1 cursor-pointer w-[18px] h-[18px] flex items-center justify-center !border !border-[#cfcfcf] bg-[#dbdbdb] rounded hover:bg-[#ccc]"
                    >
                        <FaCarOn size={8} color="#333"/>
                    </div>
                </>
            }
        </>
    )

    const image = () => {
        if (!toggleItemsNode.vehicle.last_passage) return null

        return (
            <>
                <div className={"border-top !border-[#cfcfcf] bg-[#f3f3f4]"}>
                    <div>
                        <img
                            src={`${API_URL}/passage/get-image/?url=${data.lastPassage}`}
                            alt={`passage-image`}
                            className="m-auto h-full w-full object-contain"
                            onError={(e) => {
                                e.target.src = `${API_URL}/public/assets/img/sentry.imgnotfound.large.748x480.png`;
                            }}
                        />
                    </div>
                </div>
            </>
        )
    }

    return (
        <BaseNode
            image={image()}
            icon={icon}
            title={title}
            infoBlock={infoBlock}
            onSearchConnections={() => {
            }}
            onExtraAction={open}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={""}
            bgBody={"bg-[#eeeeee]"}
            onSearchPassage={onSearchPassage}
            infoPassage={infoPassage}
            type={Types.VEHICLE}
            width={"w-[100px]"}
        />
    );
};

export default Vehicle;
